<a
    *ngIf="!isset"
    [href]="loginUrl"
    class="message--module-inactive message--module-inactive--mailchimp"
    (click)="activeModal.dismiss()">
    <strong>Your mailchimp key has not been set.</strong>
    <small>Click to add your key.</small>
</a>
